<template>
  <div class="document-debtor">
    <table>
      <tr>
        <th>구분</th>
        <th>내용</th>
      </tr>
      <tr>
        <td>서비스명</td>
        <td>{{ organization?.name }}</td>
      </tr>
      <tr>
        <td>제휴서비스</td>
        <td>선정산, 대출 서비스 등</td>
      </tr>
      <tr>
        <td>운영수수료</td>
        <td>{{ feeMessage }}(부가세 포함)</td>
      </tr>
      <tr>
        <td>이체수수료</td>
        <td>일 {{ Number(feeSetting?.transferFeeValue || 0).toLocaleString() }}원</td>
      </tr>
      <tr>
        <td>서비스 개시일</td>
        <td>계약서 작성후 매출계좌 변경 완료일 익일부터</td>
      </tr>
      <tr>
        <td>대금지급방법</td>
        <td>선정산 지급시 차감지급<br />또는 월 1회출금(월정액에 한함)</td>
      </tr>
    </table>
    <div>
      - 월정액의 경우, 첫달은 (이용일수/일수)*월정액요금으로 한다.<br />
      - 월정액은 서비스 시작일과 매월 같은날 징수됨.
    </div>
  </div>
</template>

<script>
import { mapActions, mapState } from 'vuex'

export default {
  components: {},
  data() {
    return {
      feeSetting: null,
    }
  },
  computed: {
    ...mapState('myfinbiz', ['organization']),
    feeTypes() {
      return {
        monthly_amount: '월정액',
        daily_amount: '일정액',
        daily_rate: '일정률',
      }
    },
    feeMessage() {
      if (!this.feeSetting) {
        return ''
      }
      const feeType = this.feeTypes[this.feeSetting.feeType]
      const suffix = feeType.includes('정액') ? '원' : '%'
      const value = Number(this.feeSetting.feeValue)
      const feeValue = feeType.includes('정액')
        ? value.toLocaleString()
        : (value * 100).toFixed(2).replace(/(\.\d*[1-9])0+$|\.00$/, '$1')
      return `${feeType} ${feeValue}${suffix}`
    },
  },
  async created() {
    this.feeSetting = await this.getCustomerFeeSettingsCurrent()
  },
  methods: {
    ...mapActions('myfinbiz', ['getCustomerFeeSettingsCurrent']),
  },
}
</script>

<style lang="scss" scoped>
@import '@/assets/scss/common/_variables.scss';

.document-debtor {
  table {
    width: 100%;
    background-color: white;
    border: solid 1px #727d8c;
    border-collapse: collapse;

    tr {
      th {
        height: 48px;
        border: solid 1px #727d8c;
      }
      td {
        height: 48px;
        border: solid 1px #727d8c;
      }
      td:first-child {
        width: calc(136% / 325 * 100);
        font-weight: 600;
        font-size: 15px;
        line-height: 2.13;
        text-align: center;
        color: $black;
      }
      td:last-child {
        font-weight: 900;
        font-size: 16px;
        line-height: 2;
        text-align: center;
        color: $black;
      }
    }
  }
}
</style>
